/* AppTileCompact.tsx generated by @compiled/babel-plugin v0.36.0 */
// This file is copy from AppTile.tsx and is used to render the app tile in a compact way.
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyNormal, H5 } from '@atlassian/mpac-primitives';
import { useMountPath } from '@atlassian/mpac-utils';
import { Link } from 'react-router-dom';
import { getBootstrapLinks } from '../../Config';
import { TEST_IDS } from '../../primitives/testIds';
import { AppLogoSmall } from './AppLogoSmall';
import { AppLogoWrapperCompact, AppNameWrapper, AppTileContainer, AppTileHeaderCompact, AppTileLinkCompact } from './AppTile.styles';
import { createTileClickHandler, getAppListingUrl, getAppLogoUrl, getAppName, getTagLine } from './AppTile.utils';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _51 = "._1wyboxwj{font-size:.875rem}";
const _50 = "._1bsb1osq{width:100%}";
const _49 = "._p12f1osq{max-width:100%}";
const _48 = "._1e0c1ule{display:block}";
const _47 = "._vwz4pxbi{line-height:var(--ds-space-200,1pc)}";
const _46 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _45 = "._1wyboqnp{font-size:.75rem}";
const _44 = "._k48pi7a9{font-weight:var(--ds-font-weight-regular,400)}";
const _43 = "@media (min-width:64rem){._3p1c140y{font-size:var(--ds-font-heading-xsmall,normal 600 14px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}._py5ov47k{line-height:var(--ds-space-250,20px)}}";
const _42 = "._vwz4v47k{line-height:var(--ds-space-250,20px)}";
const _41 = "._1wyb140y{font-size:var(--ds-font-heading-xsmall,normal 600 14px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _40 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const _39 = "._o5721q9c{white-space:nowrap}";
const _38 = "._1bto1l2s{text-overflow:ellipsis}";
const _37 = "._ect41gqc{font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _36 = "._18s8ze3t{margin:var(--ds-space-0,0)}";
const _35 = "._18m915vq{overflow-y:hidden}";
const _34 = "._1reo15vq{overflow-x:hidden}";
const _33 = "._4cvr1h6o{align-items:center}";
const _32 = "._1bah1h6o{justify-content:center}";
const _31 = "._bfhk18uv{background-color:initial}";
const _30 = "._2rkou2gc{border-radius:var(--ds-space-100,8px)}";
const _29 = "._1yt4v77o{padding:var(--ds-space-025,2px)}";
const _28 = "._1bah1yb4{justify-content:space-between}";
const _27 = "._4cvr1y6m{align-items:flex-start}";
const _26 = "._1wpz1fhb{align-self:stretch}";
const _25 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _24 = "._irr3108i:hover{background-color:var(--ds-surface-hovered,#f1f2f4)}";
const _23 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _22 = "._1bnxglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _21 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _20 = "._1ah3133k:focus-visible{outline-offset:.125rem}";
const _19 = "._1w0vnqa1:focus-visible{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _18 = "._10xfglyw:focus-visible{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _17 = "._vjfr18uv:focus-visible{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _16 = "._1ygb10jx:focus-visible{outline:var(--_17zcob1)}";
const _15 = "._4t3i1osq{height:100%}";
const _14 = "._p12f1dfx{max-width:32.5rem}";
const _13 = "._2lx21bp4{flex-direction:column}";
const _12 = "._1e0c1txw{display:flex}";
const _11 = "._80omtlke{cursor:pointer}";
const _10 = "._kqswh2mm{position:relative}";
const _9 = "._vchhusvi{box-sizing:border-box}";
const _8 = "._19itkxja{border:var(--_1aje98t)}";
const _7 = "._ajmmnqa1{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _6 = "._1hmsglyw{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _5 = "._4bfu18uv{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _4 = "._v56416gf{transition:box-shadow .2s ease-in-out}";
const _3 = "._11q7vuon{background:var(--ds-surface,#fff)}";
const _2 = "._2rko12x7{border-radius:var(--ds-space-075,6px)}";
const _ = "._1yt414m2{padding:var(--_xjjcaz)}";
const AppTileContainerStyle = null;
const AppContentStyle = null;
const AppHeaderStyle = null;
const AppIconWrapperStyle = null;
const AppNameStyle = null;
const HeadingStyle = null;
const PartnerDetailsWrapperStyle = null;
const TaglineStyle = null;

// eslint-disable-next-line max-lines-per-function
export function AppTileCompact(_ref) {
  let {
    tileData,
    environment,
    source,
    hideTagline = false,
    hidePartnerDetails = false,
    onTileClick,
    tileRef,
    preferredHosting
  } = _ref;
  const {
    enableMediaFromProductListing,
    enableScalingLogicOnUI,
    enableMpacWebCoherence
  } = useStatsig();
  const links = getBootstrapLinks(environment);
  const mountPath = useMountPath();
  const appLogoUrl = getAppLogoUrl(tileData, {
    enableMediaFromProductListing: enableMediaFromProductListing(),
    enableScalingLogicOnUI: enableScalingLogicOnUI(),
    links
  }, true);
  const appName = getAppName(tileData);
  const tagLine = getTagLine(tileData);
  const onTileClickHandler = createTileClickHandler(tileData, onTileClick);
  const partner = tileData.vendor;
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24]
      }), /*#__PURE__*/_jsx(Link, {
        to: getAppListingUrl(source, tileData, mountPath, preferredHosting),
        onClick: onTileClickHandler,
        "data-testid": TEST_IDS.APP_TILE,
        innerRef: tileRef,
        className: ax(["_1yt414m2 _2rko12x7 _11q7vuon _v56416gf _4bfu18uv _1hmsglyw _ajmmnqa1 _19itkxja _vchhusvi _kqswh2mm _80omtlke _1e0c1txw _2lx21bp4 _p12f1dfx _4t3i1osq _1ygb10jx _vjfr18uv _10xfglyw _1w0vnqa1 _1ah3133k _9oik18uv _1bnxglyw _jf4cnqa1 _irr3108i"]),
        style: {
          "--_xjjcaz": ix("var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-200, 16px)")),
          "--_1aje98t": ix("0.0625rem solid ".concat("var(--ds-border, #091E4224)")),
          "--_17zcob1": ix("0.125rem solid ".concat("var(--ds-border-focused, #388BFF)"))
        },
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_25, _12, _13, _26, _27, _28]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_zulpu2gc _1e0c1txw _2lx21bp4 _1wpz1fhb _4cvr1y6m _1bah1yb4"]),
            children: [/*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_25, _12]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_zulpu2gc _1e0c1txw"]),
                children: [/*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_29, _30, _31, _12, _32, _33]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_1yt4v77o _2rkou2gc _bfhk18uv _1e0c1txw _1bah1h6o _4cvr1h6o"]),
                    children: /*#__PURE__*/_jsx(AppLogoSmall, {
                      alt: tileData.name,
                      loading: "lazy",
                      src: appLogoUrl,
                      "aria-hidden": "true"
                    })
                  })]
                }), /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_34, _35, _12, _13, _26, _27]
                  }), /*#__PURE__*/_jsxs("div", {
                    className: ax(["_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1wpz1fhb _4cvr1y6m"]),
                    children: [/*#__PURE__*/_jsxs(CC, {
                      children: [/*#__PURE__*/_jsx(CS, {
                        children: [_34, _35, _36, _37, _38, _39, _40, _41, _42, _43]
                      }), /*#__PURE__*/_jsx(H5, {
                        className: ax(["_1reo15vq _18m915vq _18s8ze3t _ect41gqc _1bto1l2s _o5721q9c _k48p1wq8 _1wyb140y _vwz4v47k _3p1c140y _py5ov47k"]),
                        children: appName
                      })]
                    }), !hidePartnerDetails && /*#__PURE__*/_jsxs(CC, {
                      children: [/*#__PURE__*/_jsx(CS, {
                        children: [_36, _34, _35, _44, _45, _46, _47, _39, _38, _48, _49]
                      }), /*#__PURE__*/_jsxs(BodyNormal, {
                        className: ax(["_18s8ze3t _1reo15vq _18m915vq _k48pi7a9 _1wyboqnp _syaz1gjq _vwz4pxbi _o5721q9c _1bto1l2s _1e0c1ule _p12f1osq"]),
                        children: ["by ", partner.name]
                      })]
                    })]
                  })]
                })]
              })]
            }), !hideTagline && /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_34, _35, _36, _44, _38, _39, _26, _27, _50, _51, _46]
              }), /*#__PURE__*/_jsx(BodyNormal, {
                className: ax(["_1reo15vq _18m915vq _18s8ze3t _k48pi7a9 _1bto1l2s _o5721q9c _1wpz1fhb _4cvr1y6m _1bsb1osq _1wyboxwj _syaz1gjq"]),
                children: tagLine
              })]
            })]
          })]
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(AppTileContainer, {
    children: /*#__PURE__*/_jsxs(AppTileLinkCompact, {
      to: getAppListingUrl(source, tileData, mountPath, preferredHosting),
      onClick: onTileClickHandler,
      "data-testid": TEST_IDS.APP_TILE,
      innerRef: tileRef,
      children: [/*#__PURE__*/_jsxs(AppTileHeaderCompact, {
        children: [/*#__PURE__*/_jsx(AppLogoWrapperCompact, {
          children: /*#__PURE__*/_jsx(AppLogoSmall, {
            alt: tileData.name,
            loading: "lazy",
            src: appLogoUrl,
            "aria-hidden": "true"
          })
        }), /*#__PURE__*/_jsxs(AppNameWrapper, {
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_34, _35, _36, _37, _38, _39, _40, _41, _42, _43]
            }), /*#__PURE__*/_jsx(H5, {
              className: ax(["_1reo15vq _18m915vq _18s8ze3t _ect41gqc _1bto1l2s _o5721q9c _k48p1wq8 _1wyb140y _vwz4v47k _3p1c140y _py5ov47k"]),
              children: appName
            })]
          }), !hidePartnerDetails && /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_36, _34, _35, _44, _45, _46, _47, _39, _38, _48, _49]
            }), /*#__PURE__*/_jsxs(BodyNormal, {
              className: ax(["_18s8ze3t _1reo15vq _18m915vq _k48pi7a9 _1wyboqnp _syaz1gjq _vwz4pxbi _o5721q9c _1bto1l2s _1e0c1ule _p12f1osq"]),
              children: ["by ", partner.name]
            })]
          })]
        })]
      }), !hideTagline && /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_34, _35, _36, _44, _38, _39, _26, _27, _50, _51, _46]
        }), /*#__PURE__*/_jsx(BodyNormal, {
          className: ax(["_1reo15vq _18m915vq _18s8ze3t _k48pi7a9 _1bto1l2s _o5721q9c _1wpz1fhb _4cvr1y6m _1bsb1osq _1wyboxwj _syaz1gjq"]),
          children: tagLine
        })]
      })]
    })
  });
}